import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ReportType } from '@navstation-portal/shared/data-model/report-type';
import { IconName, IconNames } from '@navstation-portal/shared/data-model/ui';
import { IconComponent } from '@navstation-portal/shared/ui/components';

@Component({
  selector: 'nsp-report-badge',
  templateUrl: './report-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgClass],
})
export class ReportBadgeComponent {
  reportType = input<ReportType>();

  private readonly bgColorsByReportType: Record<ReportType, string> = {
    [ReportType.Anchor]: 'bg-[#8b9eb0]/50',
    [ReportType.Sea]: 'bg-[#0ea5c5]/50',
    [ReportType.Departure]: 'bg-[#f97316]/50',
    [ReportType.Port]: 'bg-[#7c6fcd]/50',
    [ReportType.Maneuvering]: 'bg-[#f4c430]/50',
    [ReportType.SeaArrival]: 'bg-[#22c55e]/50',
    [ReportType.Drifting]: 'bg-[#ff6347]/50',
  } as const;

  private readonly iconsByReportType: Record<ReportType, IconName> = {
    [ReportType.Anchor]: IconNames.Anchor,
    [ReportType.Sea]: IconNames.Water,
    [ReportType.Departure]: IconNames.ArrowRightFromBracket,
    [ReportType.Port]: IconNames.LocationDot,
    [ReportType.Maneuvering]: IconNames.Compass,
    [ReportType.SeaArrival]: IconNames.ArrowRightToBracket,
    [ReportType.Drifting]: IconNames.Route, // Assuming a generic icon for Drifting
  } as const;

  readonly iconName = computed<IconName>(() => {
    const reportType = this.reportType();
    return reportType ? this.iconsByReportType[reportType] : IconNames.Circle;
  });

  readonly reportTypeDisplay = computed<string>(() => {
    const reportType = this.reportType();
    return reportType ? reportType : 'Unknown';
  });

  bgColorClass = computed<string>(() => {
    const reportType = this.reportType();
    return reportType ? this.bgColorsByReportType[reportType] : 'bg-gray-500';
  });
}
